import * as httpx from "httpx"
import { CancellablePromise } from "real-cancellable-promise"

export interface TextCorrection {
	id: string
	account_id: string
	brand_id: string
	event_id: string
	status: "pending" | "processing" | "complete" | "failed"
	model: string
	prompt_hash: string
	corrected_event_id?: string
	error_message?: string
	created_at: string
	completed_at?: string
	tombstoned_at?: string
}

export function create(eventId: string, ...options: httpx.option[]): CancellablePromise<TextCorrection> {
	return httpx.post<TextCorrection>(`${httpx.urlstorage.host()}/bg/corrections/text/event/${eventId}`, {}, ...options)
}

export function find(correctionId: string, ...options: httpx.option[]): CancellablePromise<TextCorrection> {
	return httpx.get<TextCorrection>(`${httpx.urlstorage.host()}/bg/corrections/text/${correctionId}`, {}, ...options)
}

export function list(eventId: string, ...options: httpx.option[]): CancellablePromise<TextCorrection[]> {
	return httpx.get<TextCorrection[]>(`${httpx.urlstorage.host()}/bg/corrections/text/event/${eventId}`, {}, ...options)
}
